var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ad-group-list-container" },
    [
      _c("YDSearchForm", {
        attrs: {
          "form-items": _vm.searchFormItems,
          "initial-values": _vm.initVals,
          permi: "user_advertising_edit",
          "use-cache": true,
          "cache-options": {
            type: "session",
            key: "adGroupParams",
          },
        },
        on: {
          search: _vm.handleSearch,
          reset: _vm.handleReset,
          add: _vm.addAdGroup,
        },
        scopedSlots: _vm._u([
          {
            key: "createTimeSlot",
            fn: function (ref) {
              var formData = ref.formData
              return [
                _c("el-date-picker", {
                  staticStyle: { width: "100%" },
                  attrs: {
                    type: "date",
                    placeholder: "选择日期",
                    "value-format": "yyyy-MM-dd",
                  },
                  model: {
                    value: formData.createTime,
                    callback: function ($$v) {
                      _vm.$set(formData, "createTime", $$v)
                    },
                    expression: "formData.createTime",
                  },
                }),
              ]
            },
          },
        ]),
      }),
      _c(
        "yd-table",
        {
          ref: "adGroupTable",
          attrs: {
            data: _vm.tableData,
            pagination: _vm.pagination,
            loading: _vm.loading,
          },
          on: { onChange: _vm.onTableChange },
        },
        [
          _c("el-table-column", {
            attrs: { prop: "id", label: "ID", width: "80", align: "center" },
          }),
          _c("el-table-column", {
            attrs: { prop: "name", label: "广告组名称", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-link",
                      {
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.openAdGroupDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v(_vm._s(scope.row.name))]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              prop: "weights",
              label: "权重",
              width: "80",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "bannerDisplayPage",
              label: "展示页面",
              width: "120",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "状态", width: "120", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "span",
                      { class: ["status-text", "status-" + scope.row.state] },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(scope.row.stateStr) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: { prop: "createUserName", label: "创建人", align: "center" },
          }),
          _c("el-table-column", {
            attrs: {
              prop: "createTime",
              label: "创建时间",
              width: "180",
              align: "center",
            },
          }),
          _c("el-table-column", {
            attrs: { label: "操作", width: "280", align: "center" },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "div",
                      { staticClass: "operation-buttons" },
                      [
                        _vm.btnBold("edit", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_edit"],
                                    expression: "['user_advertising_edit']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.editAdGroup(scope.row)
                                  },
                                },
                              },
                              [_vm._v("编辑")]
                            )
                          : _vm._e(),
                        _vm.btnBold("submitAudit", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_submitAudit"],
                                    expression:
                                      "['user_advertising_submitAudit']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAdGroupStatus(1, scope.row)
                                  },
                                },
                              },
                              [_vm._v("提交审核")]
                            )
                          : _vm._e(),
                        _vm.btnBold("pass", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_review"],
                                    expression: "['user_advertising_review']",
                                  },
                                ],
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAdGroupStatus(3, scope.row)
                                  },
                                },
                              },
                              [_vm._v("通过")]
                            )
                          : _vm._e(),
                        _vm.btnBold("noPass", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_review"],
                                    expression: "['user_advertising_review']",
                                  },
                                ],
                                staticClass: "danger-button",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAdGroupStatus(4, scope.row)
                                  },
                                },
                              },
                              [_vm._v("不通过")]
                            )
                          : _vm._e(),
                        _vm.btnBold("configBanner", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_configBanner"],
                                    expression:
                                      "['user_advertising_configBanner']",
                                  },
                                ],
                                staticClass: "primary-button",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openBannerDialog(
                                      scope.row,
                                      "config"
                                    )
                                  },
                                },
                              },
                              [_vm._v("配置banner")]
                            )
                          : _vm._e(),
                        _vm.btnBold("hide", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_hide"],
                                    expression: "['user_advertising_hide']",
                                  },
                                ],
                                staticClass: "orange-button",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAdGroupStatus(5, scope.row)
                                  },
                                },
                              },
                              [_vm._v("隐藏")]
                            )
                          : _vm._e(),
                        _vm.btnBold("enable", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_enable"],
                                    expression: "['user_advertising_enable']",
                                  },
                                ],
                                staticClass: "green-button",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.openBannerDialog(
                                      scope.row,
                                      "enable"
                                    )
                                  },
                                },
                              },
                              [_vm._v("启用")]
                            )
                          : _vm._e(),
                        _vm.btnBold("delete", scope.row)
                          ? _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "has-permi",
                                    rawName: "v-has-permi",
                                    value: ["user_advertising_delete"],
                                    expression: "['user_advertising_delete']",
                                  },
                                ],
                                staticClass: "danger-button",
                                attrs: { type: "text", size: "mini" },
                                on: {
                                  click: function ($event) {
                                    return _vm.setAdGroupStatus(2, scope.row)
                                  },
                                },
                              },
                              [_vm._v("删除")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("AdGroupDetail", {
        attrs: {
          visible: _vm.detailVisible,
          adGroupId: _vm.currentAdGroup ? _vm.currentAdGroup.id : "",
        },
        on: {
          "update:visible": function ($event) {
            _vm.detailVisible = $event
          },
        },
      }),
      _vm.bannerDialogVisible
        ? _c("AdGroupBannerDialog", {
            attrs: {
              visible: _vm.bannerDialogVisible,
              adGroupId: _vm.currentAdGroup ? _vm.currentAdGroup.id : "",
              adGroupName: _vm.currentAdGroup ? _vm.currentAdGroup.name : "",
              templateId: _vm.currentAdGroup
                ? _vm.currentAdGroup.templateId
                : "",
              displayPageName: _vm.currentAdGroup
                ? _vm.currentAdGroup.bannerDisplayPage
                : "",
              mode: _vm.mode,
            },
            on: {
              "update:visible": function ($event) {
                _vm.bannerDialogVisible = $event
              },
              confirm: function ($event) {
                return _vm.setAdGroupStatus(6, _vm.currentAdGroup)
              },
            },
          })
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.currentAdGroup
              ? "编辑广告组: " +
                (_vm.currentAdGroup.adGroup
                  ? _vm.currentAdGroup.adGroup.name
                  : "")
              : "编辑广告组",
            visible: _vm.simpleEditorVisible,
            width: "900px",
            "before-close": _vm.handleSimpleEditorClose,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.simpleEditorVisible = $event
            },
          },
        },
        [
          _vm.simpleEditorVisible && _vm.currentAdGroup
            ? _c("AdGroupSimpleEditor", {
                ref: "simpleEditor",
                attrs: { currentAdGroup: _vm.currentAdGroup, "is-edit": true },
              })
            : _vm._e(),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleSimpleEditorClose } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleSimpleEditorSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("RejectDialog", {
        attrs: {
          visible: _vm.rejectDialogVisible,
          bannerId: _vm.currentAdGroup ? _vm.currentAdGroup.id : "",
          type: "adGroup",
        },
        on: {
          "update:visible": function ($event) {
            _vm.rejectDialogVisible = $event
          },
          confirm: _vm.handleRejectConfirm,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }